import apiClient from './client';

export interface TiktokAdgroupWithMapping {
  adgroupId: string;
  adgroupName: string;
  status: string;
  mappedFormName: string | null;
}

export interface ZohoFormOption {
  formName: string;
  count: number; // recent-deal volume, drives sort order in the dropdown
}

export interface TiktokFormMapping {
  _id: string;
  accountId: string;
  adgroupId: string;
  adgroupName: string;
  formName: string;
  updatedAt: string;
  createdAt: string;
}

export async function listMappings(): Promise<TiktokFormMapping[]> {
  const res = await apiClient.get('/tiktok-mappings/');
  return res.data.mappings;
}

export async function listAdgroupsForAccount(
  accountId: string
): Promise<TiktokAdgroupWithMapping[]> {
  const res = await apiClient.get(`/tiktok-mappings/adgroups/${accountId}`);
  return res.data.adgroups;
}

export async function listZohoForms(): Promise<ZohoFormOption[]> {
  const res = await apiClient.get('/tiktok-mappings/forms');
  return res.data.forms;
}

export async function upsertMapping(payload: {
  accountId: string;
  adgroupId: string;
  adgroupName: string;
  formName: string;
}): Promise<TiktokFormMapping> {
  const res = await apiClient.put('/tiktok-mappings/', payload);
  return res.data.mapping;
}

export async function deleteMapping(
  accountId: string,
  adgroupId: string
): Promise<void> {
  await apiClient.delete(`/tiktok-mappings/${accountId}/${adgroupId}`);
}
